

const SSO_CONFIG = {
    development: 'https://ssotemp.winpow.com', // 测试服
    // production: 'https://ssotemp.winpow.com', //打包测试
    staging: 'https://ssotemp.winpow.com',
    production: 'https://sso.winpow.com', //正式
}

export default {
    SSO_CONFIG: SSO_CONFIG
}



